import { render, staticRenderFns } from "./MoviesPremiers.vue?vue&type=template&id=ca2446d8&"
import script from "./MoviesPremiers.vue?vue&type=script&lang=js&"
export * from "./MoviesPremiers.vue?vue&type=script&lang=js&"
import style0 from "./MoviesPremiers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports